import { render, staticRenderFns } from "./ListservicePoint.vue?vue&type=template&id=4071e2dd&scoped=true"
import script from "./ListservicePoint.vue?vue&type=script&lang=js"
export * from "./ListservicePoint.vue?vue&type=script&lang=js"
import style0 from "./ListservicePoint.vue?vue&type=style&index=0&id=4071e2dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071e2dd",
  null
  
)

export default component.exports